import { createContext, useContext } from "react";

export type ToastTone = "pos" | "info" | "danger";

export interface ToastApi {
  /** Show a transient confirmation bottom-right; auto-dismissed, never blocks the page. */
  toast: (message: string, tone?: ToastTone) => void;
}

/** Provided by `components/toaster.tsx`; the default is a no-op so a screen renders without it. */
export const ToastContext = createContext<ToastApi>({ toast: () => {} });

/**
 * Success feedback for a completed action ("Імʼя оновлено."). Errors do not go here — they
 * stay inline, next to the field that caused them, where the user has to act.
 */
export function useToast(): ToastApi {
  return useContext(ToastContext);
}
